<template>
    <van-popup class="popWrap" v-model="show" @close="close" position="bottom" round :lazy-render="false" closeable :get-container="getContainer" :style="{maxHeight: '95%'}">
    <div class="tsa-sharePermissionsSettingDialog">
        <!-- <div class="mask"></div> -->
        <div class="content">
            <!-- <img src="../../../../../assets/images/close3.png" class="close" @click="close" alt=""> -->
            <h2>权限设置</h2>
            <h3>用于设置<span>证书验证/</span><span>扫码查看/</span><span>作品分享</span>时版权认证证书中<span>已认证文件</span>的访问权限</h3>
            <div class="setting-container">
                <div class="sub-title">
                    <p>已认证文件的访问权限</p>
                </div>
                <div class="setting-actions">
                    <div class="item">
                        <div class="name">
                            <p>访问权限有效期：</p>
                        </div>
                        <div class="value">
                            <div class="raido">
                                <TsaRadioV2 v-model="setupDuration" :trueLabel="-1" :falseLabel="0" @on-change="longTermChange">长期有效</TsaRadioV2>
                            </div>
                            <div class="raido customDate is-customed">
                                <TsaRadioV2 v-model="setupDuration" :trueLabel="0" :falseLabel="-1">自定义到期日</TsaRadioV2>
                            </div>
                            <el-input
                                placeholder="请选择日期"
                                suffix-icon="el-icon-date"
                                v-show="setupDuration === 0"
                                v-model="chooseDate"
                                @focus="showTypePicker"
                                ref="inputSelect"
                            >
                            </el-input>
                            <van-popup v-model="showDatePop" position="bottom" round>
                                <van-datetime-picker
                                    v-model="currentDate"
                                    :min-date="minDate"
                                    :max-date="maxDate"
                                    cancel-button-text="重置"
                                    title="选择日期"
                                    type="date"
                                    @cancel="showDatePop=false"
                                    @confirm="dateConfirm"
                                />
                            </van-popup>

                            <!-- <TsaConditionDateV2
                                v-show="setupDuration === 0"
                                type="date"
                                v-model="setupExpiredAt"
                                placeholder="请选择时间"
                                valueFormat="timestamp"
                                :pickerOptions="pickerOptions"
                            >
                            </TsaConditionDateV2> -->
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">
                            <p>访问码：</p>
                        </div>
                        <div class="value">
                            <div class="raido">
                                <TsaRadioV2 v-model="accessStatus" :trueLabel="0" :falseLabel="1" @on-change="handleAccessStatusChange">不需要访问码</TsaRadioV2>
                            </div>
                            <div class="raido">
                                <TsaRadioV2 v-model="accessStatus" :trueLabel="1" :falseLabel="0" @on-change="handleAccessStatusChange">随机生成</TsaRadioV2>
                            </div>
                            <div class="raido is-customed">
                                <TsaRadioV2 v-model="accessStatus" :trueLabel="2" :falseLabel="0" @on-change="handleAccessStatusChange">自定义</TsaRadioV2>
                            </div>
                            <TsaConditionSearchV21
                                v-show="accessStatus === 2"
                                v-model="accessCode"
                                clearable
                                :format="/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g"
                                :maxlength="6"
                                placeholder="输入6位访问码，仅支持数字及字母"
                            >
                            </TsaConditionSearchV21>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-container-scroll">
                <div class="table-container">
                <div class="custom-table-header" v-show="someOne">
                    <div class="left">
                        <div class="checkbox" @click="checkedAllFun">
                            <span class="icon" :class="checkedCount === tableData.length ? 'tsa-icon-duoxuan-quanxuan' : 'tsa-icon-duoxuan-banxuan'"></span>
                            <p>全选</p>
                        </div>
                        <div class="info">
                            <p>已选中 <span>{{ allCheckedCount }}</span> 个文件</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="name">批量设置：</div>
                        <div class="value">
                            <TsaCheckboxV2 v-model="viewPermissionAll" :disabled="disabled" :indeterminate="viewPermissionIndeterminate" :trueLabel="1" :falseLabel="0" @on-change="viewPermissionAllFun">允许他人查看内容</TsaCheckboxV2>
                            <TsaCheckboxV2 v-model="downloadFilePermissionAll" :disabled="disabled" :indeterminate="downloadFilePermissionIndeterminate" :trueLabel="1" :falseLabel="0" @on-change="downloadFilePermissionAllFun">允许他人下载文件</TsaCheckboxV2>
                            <TsaCheckboxV2 v-model="downloadPdfPermissionAll" :disabled="disabled" :indeterminate="downloadPdfPermissionIndeterminate" :trueLabel="1" :falseLabel="0" @on-change="downloadPdfPermissionAllFun">允许他人下载证书</TsaCheckboxV2>
                        </div>
                    </div>
                </div>
                <TsaTable
                    :data="tableData"
                    ref="TsaTableV2"
                    maxHeight="400"
                    customRowKey="id"
                    stripe
                    :showHeader="someOne ? false : true"
                    :row-class-name="rowClassName"
                    @selection-change="selectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="28"
                        >
                        <template slot-scope="scope">
                            <TsaCheckboxV2 shape="square" v-model="scope.row.checked" color="#2468F2" @on-change="tableCheckbox(scope.row)"></TsaCheckboxV2>
                        </template>
                    </el-table-column>
                    <el-table-column
                        type="index"
                        width="60"
                        align="left"
                        label="序号">
                        <template slot-scope="scope">{{ scope.$index + 1 > 9 ? scope.$index + 1 : '0' + (scope.$index + 1) }}</template>
                    </el-table-column>
                    <el-table-column prop="fileName" label="文件名称" align="left"  width="200">
                        <template slot-scope="scope">
                            <div class="cell-container">
                                {{ scope.row.fileName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="viewPermission" label="允许他人查看内容" width="160" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="table-checkbox-container">
                                <TsaCheckboxV2 v-model="scope.row.viewPermission" :trueLabel="1" :falseLabel="0" @on-change="tableViewPermission(scope.row)">允许</TsaCheckboxV2>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="downloadFilePermission" label="允许他人下载文件" width="160" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="table-checkbox-container">
                                <TsaCheckboxV2 v-model="scope.row.downloadFilePermission" :trueLabel="1" :falseLabel="0" @on-change="tableDownloadFilePermission(scope.row)">允许</TsaCheckboxV2>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="downloadPdfPermission" label="允许他人下载证书" width="176" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="table-checkbox-container">
                                <TsaCheckboxV2 v-model="scope.row.downloadPdfPermission" :trueLabel="1" :falseLabel="0" @on-change="tableDownloadPdfPermission(scope.row)">允许</TsaCheckboxV2>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="40">
                    </el-table-column>
                </TsaTable>
                </div>
            </div>
            <div class="pager-container">
                <TsaPager2 v-if="tableData.length > 0" @current-change="currentChange" @size-change="handleSizeChange" :total="total" :current-page.sync="condition.page" :page-size="condition.size" :page-sizes="pageSizes"/>
            </div>
        </div>
        <div class="btn-group">
            <div class="btn">
                <TsaButton plain size="mediumer" type="default" @click="cancel">取消</TsaButton>
            </div>
            <div class="btn">
                <TsaButton size="mediumer" @click="confirm">确定</TsaButton>
            </div>
        </div>
    </div>
    </van-popup>
</template>

<script>
import { findShareInfoApi, shareFilePageApi, shareApi } from '@/api/copyright/drama'
import tableConfig from '@/config/copyright/tableConfig'
import commonMixins from '../mixins/common'
import {formatYMD} from '@/utils/filter.js'
import dayjs from 'dayjs'
export default {
    components: {
        
    },
    data () {
        return {
            // // 是否需要访问码（0否 1是 2自定义）
            accessStatus: null,
            // 访问码
            accessCode: null,
            // 配置有效期(天) -1无限制 0自定义
            setupDuration: null,
            // 过期日期
            setupExpiredAt: null,
            // // setupStatus 0 还未分享 1已经分享过了
            // setupStatus: null,
            viewPermissionAll: false,
            viewPermissionIndeterminate: false,
            downloadFilePermissionAll: false,
            downloadFilePermissionIndeterminate: false,
            downloadPdfPermissionAll: false,
            downloadPdfPermissionIndeterminate: false,
            pickerOptions: {
                disabledDate(v) {
                    return v.getTime() < new Date().getTime() - 86400000;//  - 86400000是否包括当天
                }
            },
            checkedAll: false,
            showDatePop:false,
            minDate: new Date(), // 最小时间设置为时间戳
            maxDate: new Date(new Date().getFullYear() + 100, new Date().getMonth(), new Date().getDate()),// 100 年后的日期作为 maxDate
            currentDate:new Date(),
            chooseDate: '',//选中时间
            scrollLeft:0,//表格的横向滚动距离
        }
    },
    computed: {
        allCheckedCount () {
            let array = []
            this.multipleSelection.map(item => {
                if (item.checked) {
                    array.push(item.id)
                } 
            })
            return array.length
        },
        checkedCount () {
            let array = []
            this.tableData.map(item => {
                if (item.checked) {
                    array.push(item.id)
                } 
            })
            if (array.length === this.tableData.length) {
                this.checkedAll = true
            } else {
                this.checkedAll = false
            }
            return array.length
        },
        someOne () {
            return this.multipleSelection.some(item => item.checked)
        },
        disabled () {
            let obj = this.tableData.find(item2 => item2.checked)
            return obj ? false : true
       }
    },
    mixins: [ commonMixins ],
    mounted () {
    },
    watch: {
        show (val) {
            if (!val) {
                // // 是否需要访问码（0否 1是 2自定义）
                this.accessStatus = null,
                // 访问码
                this.accessCode = null,
                // 配置有效期(天) -1无限制 0自定义
                this.setupDuration = null,
                // 过期日期
                this.setupExpiredAt = null,
                this.$refs.TsaTableV2.clearSelection()
                this.tableData = []
                this.condition = {
                    page: 1,
                    size: tableConfig.pageSize,
                }
                this.total = 0,
                this.multipleSelection = []
                this.checkedAll = false
            }
        },
        tableData: {
            handler (array) {
                let viewPermissionIndeterminateArray = []
                let downloadFilePermissionIndeterminateArray = []
                let downloadPdfPermissionIndeterminateArray = []
                // 截取已选中的数据
                let selectedArray = array.filter(item => item.checked)
                
                selectedArray.map(item => {
                    if (item.viewPermission === 1) {
                        viewPermissionIndeterminateArray.push(item.id)
                    }
                    if (item.downloadFilePermission === 1) {
                        downloadFilePermissionIndeterminateArray.push(item.id)
                    }
                    if (item.downloadPdfPermission === 1) {
                        downloadPdfPermissionIndeterminateArray.push(item.id)
                    }
                })

                if (viewPermissionIndeterminateArray.length === 0) {
                    this.viewPermissionAll = 0
                    this.viewPermissionIndeterminate = false
                } else if (viewPermissionIndeterminateArray.length === selectedArray.length) {
                    this.viewPermissionAll = 1
                    this.viewPermissionIndeterminate = false
                } else {
                    this.viewPermissionAll = 0
                    this.viewPermissionIndeterminate = true
                }

                if (downloadFilePermissionIndeterminateArray.length === 0) {
                    this.downloadFilePermissionAll = 0
                    this.downloadFilePermissionIndeterminate = false
                } else if (downloadFilePermissionIndeterminateArray.length === selectedArray.length) {
                    this.downloadFilePermissionAll = 1
                    this.downloadFilePermissionIndeterminate = false
                } else {
                    this.downloadFilePermissionAll = 0
                    this.downloadFilePermissionIndeterminate = true
                }
                if (downloadPdfPermissionIndeterminateArray.length === 0) {
                    this.downloadPdfPermissionAll = 0
                    this.downloadPdfPermissionIndeterminate = false
                } else if (downloadPdfPermissionIndeterminateArray.length === selectedArray.length) {
                    this.downloadPdfPermissionAll = 1
                    this.downloadPdfPermissionIndeterminate = false
                } else {
                    this.downloadPdfPermissionAll = 0
                    this.downloadPdfPermissionIndeterminate = true
                }
                
            },
            deep: true
        },
        setupExpiredAt(val){
            this.chooseDate=formatYMD(val)
            this.currentDate=new Date(val)
        }
    },
    methods: {
        getContainer() {
            return document.querySelector('.main');
        },
        showTypePicker(){
            this.showDatePop = true;
            this.$refs.inputSelect.blur();
        },
        dateConfirm(val){
            this.chooseDate=formatYMD(val.getTime())
            this.setupExpiredAt=val.getTime();
            this.showDatePop = false;
        },
        open ({ id, rightsInfo, basicInfo, certificateInfo, onConfirm } = {}) {
            this.onConfirm = onConfirm
            this.show = true
            this.rightsInfo = rightsInfo || {}
            this.certificateInfo = certificateInfo || {}
            this.basicInfo = basicInfo || {}
            this.dramaId = id
            this.accessStatus = basicInfo.accessStatus
            this.setupDuration = basicInfo.setupDuration
            this.accessCode = basicInfo.accessCode || null
            this.setupExpiredAt = basicInfo.setupExpiredAt || null
            this.tableApi()
        },
        // 表格行内样式
        rowClassName ({row, rowIndex}) {
            if (row.checked) {
                return 'active'
            } else {
                return ''
            }
        },
        close () {
            this.show = false
        },
        cancel () {
            this.show = false
        },
        hide () {
            this.show = false
        },
        expiredAtChange () {
            this.setupDuration = 0
        },
        confirm () {
            let dramaId = this.dramaId
            let accessStatus = this.accessStatus
            let accessCode = this.accessCode
            let setupDuration = this.setupDuration
            let setupExpiredAt = this.setupExpiredAt

            if (setupDuration === null) {
                this.$TsaToastV2.show({
                    message: '请设置访问权限有效期',
                    type: 'warn',
                })
                return
            }
            // setupDuration
            if (setupDuration === 0) {
                if (!setupExpiredAt) {
                    this.$TsaToastV2.show({
                        message: '请设置访问权限有效期',
                        type: 'warn',
                    })
                    return
                }
                const year = dayjs(setupExpiredAt).format('YYYY'); // 使用 format 方法获取年份
                const month = dayjs(setupExpiredAt).format('MM'); // 使用 format 方法获取月份
                const day = dayjs(setupExpiredAt).format('DD'); // 使用 format 方法获取日期
                let timestamp = dayjs(year + '-' + month + '-' + day + ' 23:59:59').valueOf()
                setupExpiredAt = timestamp.valueOf()
            } else {
                setupExpiredAt = null
            }
            if (accessStatus === null) {
                this.$TsaToastV2.show({
                    message: '请设置访问码',
                    type: 'warn',
                })
                return
            }
            // 如果选择自定义访问码
            if (accessStatus === 2) {
                if (!accessCode || accessCode.length < 6) {
                    return this.$TsaToastV2.show({
                        message: '请输入6位访问码',
                        type: 'warn',
                    })
                }
            } else {
                accessCode = null
            }
            
            // 分享文件列表
            let shareStageFileDTOList = []
            
            this.multipleSelection.forEach(item => {
                shareStageFileDTOList.push({
                    id: item.id,
                    viewPermission: item.viewPermission,
                    downloadFilePermission: item.downloadFilePermission,
                    downloadPdfPermission: item.downloadPdfPermission,
                })
            })
            
            this.$TsaLoadingV2.show()
            shareApi({
                dramaId,
                accessStatus,
                accessCode,
                setupDuration,
                setupExpiredAt,
                shareStageFileDTOList,
            }).then(({ code, data}) => {
                this.$TsaLoadingV2.hide()
                if (code === 200) {
                    this.$TsaToastV2.show({
                        message: '分享权限设置成功',
                        type: 'success',
                    })
                    let { accessStatus, setupDuration, accessCode, setupExpiredAt } = data
                    try {
                        this.$emit('on-permissionsSettingSuccess', {
                            id: this.dramaId,
                            ...this.rightsInfo,
                            ...this.basicInfo,
                            ...this.certificateInfo,
                            accessStatus, setupDuration, accessCode, setupExpiredAt,
                        })
                    } catch (error) {
                        console.log(error)
                    }
                }
            }).catch(() => {
                this.$TsaLoadingV2.hide()
            })
        },
        // 自定义日期
        handleSetupDurationClcik () {
            this.$refs.setupExpiredAtPicker.focus()
        },
        longTermChange () {
            this.setupExpiredAt = null
        },
        // 访问码变化
        handleAccessStatusClcik () {
            
        },
        handleAccessStatusChange () {
            if (this.accessStatus !== 2) {
                this.accessCode = null
            }
        },
        checkedAllFun () {
            this.checkedAll = !this.checkedAll
            console.log(this.checkedAll)
            if (!this.checkedAll) {
                this.$refs.TsaTableV2.clearSelection()
            }
            this.tableData.map(item => {
                item.checked = this.checkedAll
                this.adduMltipleSelection(item)
            })
        },
        viewPermissionAllFun (val) {
            this.tableData.forEach(item => {
                if (item.checked) {
                    item.viewPermission = val
                }
            })
        },
        downloadFilePermissionAllFun (val) {
            this.tableData.forEach(item => {
                if (item.checked) {
                    item.downloadFilePermission = val
                }
            })
        },
        downloadPdfPermissionAllFun (val) {
            this.tableData.forEach(item => {
                if (item.checked) {
                    item.downloadPdfPermission = val
                }
            })
        },
        tableCheckbox (row) {
            this.adduMltipleSelection(row)
        },
        tableViewPermission (row) {
            this.adduMltipleSelection(row)
        },
        tableDownloadFilePermission (row) {
            this.adduMltipleSelection(row)
        },
        tableDownloadPdfPermission (row) {
            this.adduMltipleSelection(row)
        },
        adduMltipleSelection (row) { 
            let index = this.multipleSelection.findIndex((item) => item.id === row.id)
            // 数据已存在
            if (index > -1) {
                this.multipleSelection.splice(index, 1, row)
            } else {
                this.multipleSelection.push(row)
            }
        },
         selectionChange (e) {
            // 不参与属性监听的不要放在data中
            console.log(e)
            if (e.length === 0) {
                return
            }
            this.checkedAll = !this.checkedAll
            e.map(item => {
                item.checked = true
                this.adduMltipleSelection(item)
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .popWrap{
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
    .tsa-sharePermissionsSettingDialog {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding:37px 16px 0;
            overflow: hidden;
            h2 {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-bottom: 8px;
            }
            h3 {
                font-size: 14px;
                color: #666666;
                margin-bottom: 30px;
                span {
                    font-weight: bold;
                    color: #000000;

                }
            }
            .setting-container {
                width: 100%;
                margin-bottom: 16px;
                .sub-title {
                    position: relative;
                    padding-left: 11px;
                    margin-bottom: 16px;
                    p {
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);
                        width: 3px;
                        height: 20px;
                        background: #2368F1;
                    }
                }
                .setting-actions {
                    background: #F8FAFF;
                    border-radius: 12px;
                    padding: 20px 16px;
                    .item {
                        display: flex;
                        flex-direction: column;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        .name {
                            width: 164px;
                            position: relative;
                            padding-left: 12px;
                            p {
                                font-size: 16px;
                                color: #000000;
                            }
                            &::after {
                                content: '';
                                position: absolute;
                                width: 4px;
                                height: 4px;
                                left: 0;
                                top: 50%;
                                transform: translateY(-50%);
                                border-radius: 50%;
                                background: #FF3333;
                            }
                        }
                        .value {
                            margin: 14px 0;
                            flex: 1;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            .raido {
                                display: flex;
                                position: relative;
                                margin-right: 13px;
                                margin-bottom: 13px;
                            }
                            .customDate {
                                margin-left: 32px;
                            }
                            /deep/.tsa-conditionSearchV2 {
                                width: 100%;
                                height: 40px;
                                line-height: 40px;
                                .el-input{
                                    .el-input__inner{
                                        height: 40px;
                                        line-height: 40px;
                                    }
                                } 
                            }
                            .is-customed {
                                margin-right: 15px;
                            }
                        }
                    }
                }
            }
            .table-container-scroll{
                width: 100%;
                flex: 1;
                overflow-x: auto;
                overflow-y: hidden;
                margin-bottom: 20px;
                position: relative;
            }
            .table-container {
                height: 100%;
                display: inline-block;
                .custom-table-header {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    background: #F1F1F1;
                    border-radius: 4px 4px 0px 0px;
                    .left {
                        display: flex;
                        align-items: center;
                        padding-left: 12px;
                        .checkbox {
                            display: flex;
                            align-items: center;
                            margin-right: 30px;
                            cursor: pointer;
                            .icon {
                                color: #2468F2;
                                margin-right: 11px;
                                font-size: 14px;
                            }
                            p {
                                font-weight: bold;
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                        .info {
                            p {
                                font-weight: bold;
                                font-size: 14px;
                                color: #666666;
                                span {
                                    color: #0047FF;
                                }
                            }
                        }
                    }
                    .right {
                        flex: 1;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .name {
                            flex-shrink: 0;
                            font-weight: bold;
                            font-size: 14px;
                            color: #666666;
                            margin-right: 6px;
                        }
                        .value {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            /deep/.tsa-checkboxV2 {
                                &:first-child {
                                    margin-right: 28px;
                                }
                                &:nth-child(2) {
                                    margin-right: 37px;
                                }
                                &:last-child {
                                    margin-right: 20px;
                                }
                                p {
                                    font-weight: bold;
                                    color: #666666;
                                }
                            }
                        }
                    }
                }
                .tsa-customTable2{
                    display: inline-block;
                    width: auto;
                }
                /deep/.el-table {
                    .el-table--scrollable-x .el-table__body-wrapper{
                        overflow-x: hidden;
                    }
                    .el-table__header {
                        th {
                            border-right: none!important;
                        }
                    }
                    .el-table__row {
                        &.active {
                            td {
                                background-color: #E6EEFF!important;
                            }
                        }
                    }
                    .cell{
                        padding: 0 !important;
                        .cell-container{
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            word-break: break-all;
                            white-space: nowrap;
                        }
                    }
                }
                .table-checkbox-container {
                    display: flex;
                    justify-content: center;
                }
            }
            .pager-container {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                margin-bottom: 16px;
            }
            
        }
        .btn-group{
            height: 76px;
            box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
            display: flex;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            .btn {
                width: 166px;
                height: 44px;
                margin: 0 10px;
            }
        }
    }

</style>